import { useState, useEffect } from 'react';
import { swReadyService } from 'utils/services';

const useSwReady = () => {
  const [ready, setReady] = useState(swReadyService.isReady());

  useEffect(() => {
    return swReadyService.subscribe(setReady);
  }, []);

  return ready;
};

export default useSwReady;
